import { isDefined } from "@clipboard-health/util-ts";
import {
  Box,
  ListItemButton as MuiListItemButton,
  type ListItemButtonProps as MuiListItemButtonProps,
} from "@mui/material";

import { CbhIcon } from "../CbhIcon";

export interface ListItemButtonProps extends Omit<MuiListItemButtonProps, "divider"> {
  dense?: boolean;
  hideCallToActionIcon?: boolean;
  divider?: boolean;
  /** Left offset of the divider, a number that is passed to theme.spacing() */
  dividerOffset?: number;
}

export function ListItemButton(props: ListItemButtonProps) {
  const { dense, children, hideCallToActionIcon, divider, dividerOffset, ...restProps } = props;

  return (
    <MuiListItemButton dense={dense} {...restProps}>
      {children}
      {!hideCallToActionIcon && <CbhIcon type="chevron-right" size="medium" />}
      {divider && (
        <Box
          sx={(theme) => ({
            position: "absolute",
            bottom: 0,
            left: isDefined(dividerOffset) ? theme.spacing(dividerOffset) : 0,
            right: 0,
            height: "1px",
            backgroundColor: theme.palette.border?.subtle,
          })}
        />
      )}
    </MuiListItemButton>
  );
}
